import { create } from 'zustand';

interface ScrollState {
  shouldScrollToTop: boolean;
  setShouldScrollToTop: (should: boolean) => void;
  scrollToTop: () => void;
}

export const useScrollStore = create<ScrollState>((set, get) => ({
  shouldScrollToTop: false,
  
  setShouldScrollToTop: (should) => set({ shouldScrollToTop: should }),
  
  scrollToTop: () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    set({ shouldScrollToTop: false });
  },
})); 